import React, { useEffect } from "react"
import { Row, Col, Space, Flex } from "antd"
import { Title } from "ui/Typography"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import ClientProfileHeader from "./ClientProfileHeader"
import ClientDetailsTabs from "./ClientDetailsTabs"
import ClientStatsCard from "./ClientStatsCard"
import ClientNotes from "./ClientNotes"
import { getClientNotes, getGuideClient } from "store/clients"
import { useTranslation } from "react-i18next"
import { LeftOutlined } from "@ant-design/icons"
import IconWithBg from "ui/IconWithBg"
import useLoaderWatchers from "modules/loader-watchers/hooks/useLoaderWatchers"
import { routes } from "router"

const ClientDetails = () => {
  const { id } = useParams()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const navigate = useNavigate()

  useLoaderWatchers({ watchers: ["clients.clientNotes", "clients.emailLogs"] })

  useEffect(() => {
    dispatch(getGuideClient(id))
    dispatch(getClientNotes({ client_id: id }))
  }, [dispatch, id])

  const handleBackToClients = () => {
    navigate(routes.guideClientsPath())
  }

  return (
      <Space direction="vertical" size={16}>
        <Flex gap={16}>
          <IconWithBg icon={<LeftOutlined />} onClick={handleBackToClients} />
          <Title level={3}>{t("client.client_details")}</Title>
        </Flex>
        <ClientProfileHeader />
        <Row gutter={24}>
          <Col xs={24} xl={{ span: 8, order: 2 }} className="mt-lg-5xl">
            <Flex vertical gap={16} className="mb-m">
              <ClientStatsCard />
              <ClientNotes />
            </Flex>
          </Col>
          <Col xs={24} xl={16}>
            <ClientDetailsTabs />
          </Col>
        </Row>
      </Space>
  )
}

export default ClientDetails
